import { MDSActionMenuWithContent } from "@/mds/components/menu/action-menu/action-menu-with-content";
import {
  MDSMenuDropdownPopover,
  MDSMenuDropdownProps,
  MDSMenuDropdownSlotName,
} from "@/mds/components/menu/menu-dropdown";
import { MDSMenuContentList } from "@/mds/components/menu/menu.types";
import { DialogTrigger } from "react-aria-components";

interface MDSActionMenuDropdownProps extends MDSMenuDropdownProps {
  contentList: MDSMenuContentList;
}

export const MDSActionMenuDropdown = ({
  contentList,
  children,
  ...props
}: MDSActionMenuDropdownProps) => {
  if (contentList.length === 0) return children;
  return (
    <DialogTrigger onOpenChange={props.onOpenChange}>
      {children}
      <MDSMenuDropdownPopover {...props}>
        <MDSActionMenuWithContent contentList={contentList} slot={MDSMenuDropdownSlotName.Menu} />
      </MDSMenuDropdownPopover>
    </DialogTrigger>
  );
};
